import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/audit-logs`);
      setLogs(Array.isArray(res.data) ? res.data : (res.data?.Logs?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching audit logs", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const exportAuditCSV = () => {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Timestamp,Admin Email,Action,Target User Email,IP Address,Details\n";

    logs.forEach((l) => {
      const detailsStr = JSON.stringify(l.details || {}).replace(/,/g, ";");
      csvContent += `${new Date(l.timestamp).toLocaleString()},${l.adminEmail},${l.action},${l.targetUserEmail || "N/A"},${l.ipAddress || "N/A"},"${detailsStr}"\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `OpenBull_AuditTrail_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#fff" }}>System Audit Trail</h2>
          <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
            Immutable SEBI-style compliance record of all administrative actions, wallet adjustments, and status changes
          </p>
        </div>

        <button onClick={exportAuditCSV} style={btnStyle}>
          📥 Export Audit CSV
        </button>
      </div>

      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading audit log...</div>
        ) : logs.length === 0 ? (
          <div style={{ padding: "24px", color: "#888", textAlign: "center" }}>No audit log entries recorded yet.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Timestamp</th>
                <th style={thStyle}>Admin Email</th>
                <th style={thStyle}>Action Taken</th>
                <th style={thStyle}>Target User</th>
                <th style={thStyle}>IP Address</th>
                <th style={thStyle}>Audit Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                  <td style={tdStyle}>{new Date(l.timestamp).toLocaleString()}</td>
                  <td style={{ ...tdStyle, color: "#ef5350", fontWeight: "bold" }}>{l.adminEmail}</td>
                  <td style={tdStyle}>
                    <span style={{ padding: "2px 8px", backgroundColor: "#2a2e39", borderRadius: "4px", fontWeight: "bold", color: "#4caf50" }}>
                      {l.action}
                    </span>
                  </td>
                  <td style={tdStyle}>{l.targetUserEmail || "N/A"}</td>
                  <td style={tdStyle}>{l.ipAddress || "N/A"}</td>
                  <td style={{ ...tdStyle, color: "#888", fontSize: "12px" }}>
                    {JSON.stringify(l.details || {})}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default AuditLogs;
